<!-- 
Shows detail of an exception log 
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="true"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="administration-exception-logs"
      module="exceptionLogs"
      nav-url="/exception-logs/:id"
    />
    <exception-log-panel :id="id" />
  </div>
</template>

<script>
import ExceptionLogPanel from "@/components/exception-logs/ExceptionLogPanel.vue";
import * as action from "@/store/exception-logs/action-types";
import * as formatting from "@/helpers/formatting.helper";

export default {
  name: "ExceptionLog",
  components: { ExceptionLogPanel },
  computed: {
    id() {
      return parseInt(this.$route.params.id);
    },
    nextPageAction() {
      return action.LIST_NEXT_PAGE;
    },
    previousPageAction() {
      return action.LIST_PREVIOUS_PAGE;
    },
    breadcrumbs() {
      return this.$store.state.exceptionLogs.view.breadcrumbs;
    },
    title() {
      return this.log.date ? formatting.longDateTime(this.log.date) : "...";
    },
    subtitle() {
      return this.log.level ? this.log.level : "";
    },
    log() {
      return this.$store.state.exceptionLogs.view.data;
    }
  }
};
</script>
